import React, { Component } from 'react'

import './LineItem.css'

class LineItem extends Component {
  constructor(props) {
    super(props);

    this.decrementQuantity = this.decrementQuantity.bind(this);
    this.incrementQuantity = this.incrementQuantity.bind(this);
  }

  decrementQuantity(lineItemId) {
    const updatedQuantity = this.props.line_item.quantity - 1
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  incrementQuantity(lineItemId) {
    const updatedQuantity = this.props.line_item.quantity + 1
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  render() {
    const product = this.props.line_item;

    return (
      <div className="line-item">
        <div className="product-details">
          {product.title}

          <div>
            <button className="minus" onClick={() => this.decrementQuantity(product.id)} />
            <span>{product.quantity}</span>
            <button className="plus" onClick={() => this.incrementQuantity(product.id)} />
          </div>
        </div>
        <div className="product-price">
          {product.line_price.replace('.',',') + ' €'}
        </div>
      </div>
    );
  }
}

export default LineItem;



// WEBPACK FOOTER //
// ./src/components/Shopify/LineItem.js